import { Box, Typography } from '@mui/material'
import { ContainedButton } from 'components/contained-button'
import { useFormatMessage } from 'localization'
import { Reload } from 'mdi-material-ui'
import React from 'react'
import { clearLocalData } from 'utilities/use-local-data'
import { appendProjectId } from 'utilities/use-navigate-project'
import { useStaticCallback } from 'utilities/use-static-callback'

const ErrorFallbackView = () => {
  const [resetPressed, setResetPressed] = React.useState(false)
  const handleResetPressed = useStaticCallback(() => {
    setResetPressed(true)
    window.location.reload()
  })
  const handleLogoutClick = useStaticCallback(() => {
    clearLocalData()
    window.location.href = appendProjectId(window.location.origin).toString()
  })

  const f = useFormatMessage()
  return (
    <div className="flex flex-col items-center m-8">
      <Typography variant="h4" color="inherit">
        {f('ERROR_PAGE_HEADER')}
      </Typography>
      <Box pb={2} />
      <Typography className="p-4" variant="body1" color="inherit">
        {f('ERROR_PAGE_INFO')}
      </Typography>
      <Box pb={4} />
      <ContainedButton
        showSpinner={resetPressed}
        endIcon={!resetPressed && <Reload />}
        color="primary"
        onClick={handleResetPressed}
        className="self-center px-4">
        {f('ERROR_PAGE_RESET_BUTTON')}
      </ContainedButton>
      <Box pb={1} />
      <ContainedButton color="secondary" onClick={handleLogoutClick} className="self-center px-4">
        {f('ERROR_PAGE_LOGOUT_BUTTON')}
      </ContainedButton>
    </div>
  )
}

export default ErrorFallbackView
